import { EMAIL_REGEX } from 'constants/constants';

/**
 * Gets the width of browser window
 * @returns {number}
 */
const screenSize = () => {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
};

/**
 * Reloads the current page without search params
 * @param {object} element - DOM Element
 */
const clearSearchParams = element => {
  element.addEventListener('click', function (e) {
    e.preventDefault();
    window.location = window.location.href.split('?')[0];
  });
};

/**
 * Validates an email
 * @param {string} email
 * @returns true or false
 */
const isValidEmail = email => EMAIL_REGEX.test(String(email).toLowerCase());

const isMobileDevice = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
      navigator.userAgent,
    )
  ) {
    return true;
  }
  return false;
};

export { screenSize, clearSearchParams, isValidEmail, isMobileDevice };
